import InvestDetailPage from './InvestDetailPage';

export default InvestDetailPage;
